jQuery( document ).ready(function($) {
  jQuery(document).on('gform_confirmation_loaded', function(event, formId){
    if(formId == 1) {
      gtag('event', 'conversion', {'send_to': 'AW-689097416/RT8cCL3lq7YBEMiVy8gC'});
      gtag('event', 'submit', {event_category: 'formulaire_contact'});
      fbq('track', 'Contact');
    } else if(formId == 2) {
      gtag('event', 'conversion', {'send_to': 'AW-689097416/-IiuCM3doLYBEMiVy8gC'});
      gtag('event', 'submit', {event_category: 'formulaire_pro'});
      fbq('track', 'ContactPro');
    }
  });

});